
import Swiper from 'swiper';
const crel = require('crel');
const ScreenSlider = require('./screen-slider').ScreenSlider;
const ScreenSlide = require('./screen-slider').ScreenSlide;
// const cl = window.console.log;
const bgCanvas = require('./bg-canvas');
const bgAnimation = require('./bg-animation');
const AudioChannel = require('./audioChannel');
const Preloader = require('./preoader').Preloader;
const soundOnOffControl = require('./sound').soundOnOffControl;
let sw;
let analyticsEvent;
let viewMode = '';


let currChannel = null;
let currChannel_timeout = null;
let autoPlay = true;
let autoAction_timeout = null;
let autoAction_delay = 7000;



const htmlToElements = (html) => {
    const template = document.createElement('template');
    template.innerHTML = html;
    return template.content.childNodes;
}

const monthName = document.querySelector('.month-label__label');

const monthsList = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь'
];

const navigationMonthLabelRender = (index = 1) => {
    monthName.innerHTML = monthsList[index -1];
};
const setMonth = (index) => {
    if (index === null || typeof index === 'undefined'){
        document.body.removeAttribute('data-month');
        return;
    }

    document.body.dataset.month = index;
    navigationMonthLabelRender(index);
};
const setNeedAction = (index) => {
    if (index === null || typeof index === 'undefined'){
        document.body.removeAttribute('data-need-action');
        return;
    }
    document.body.dataset.needAction = index;
};
const setStepValue = (num) => {
    if (num === null || typeof num === 'undefined'){
        document.body.removeAttribute('data-step');
        return;
    }
    document.body.dataset.step = num;
};


// let element1 = crel('div', { class: 'slide' }, '');
let element0 = require('../includes/intro.pug');
element0 = htmlToElements(element0)[0];

let element1 = require('../includes/synopsis-1.pug');
element1 = htmlToElements(element1)[0];

let element2 = require('../includes/synopsis-2.pug');
element2 = htmlToElements(element2)[0];

let element3 = require('../includes/synopsis-3.pug');
element3 = htmlToElements(element3)[0];

let element4 = require('../includes/synopsis-4.pug');
element4 = htmlToElements(element4)[0];

let element5 = require('../includes/synopsis-5.pug');
element5 = htmlToElements(element5)[0];

let element6 = require('../includes/synopsis-6.pug');
element6 = htmlToElements(element6)[0];

let element7 = require('../includes/synopsis-7.pug');
element7 = htmlToElements(element7)[0];

let element8 = require('../includes/synopsis-8.pug');
element8 = htmlToElements(element8)[0];

let element9 = require('../includes/synopsis-9.pug');
element9 = htmlToElements(element9)[0];

let element10 = require('../includes/synopsis-10.pug');
element10 = htmlToElements(element10)[0];

let element11 = require('../includes/synopsis-11.pug');
element11 = htmlToElements(element11)[0];

let element12 = require('../includes/synopsis-12.pug');
element12 = htmlToElements(element12)[0];


let slide0 = new ScreenSlide(element0, 1);
let slide1 = new ScreenSlide(element1, 1);
let slide2 = new ScreenSlide(element2, 2);
let slide3 = new ScreenSlide(element3, 3);
let slide4 = new ScreenSlide(element4, 4);
let slide5 = new ScreenSlide(element5, 5);
let slide6 = new ScreenSlide(element6, 6);
let slide7 = new ScreenSlide(element7, 7);
let slide8 = new ScreenSlide(element8, 8);
let slide9 = new ScreenSlide(element9, 9);
let slide10 = new ScreenSlide(element10, 10);
let slide11 = new ScreenSlide(element11, 11);
let slide12 = new ScreenSlide(element12, 12);

let stepValue = 0;

addBGLayers(12);

// CONSTRUCT AUDIO
const bgChannel = new AudioChannel('bgChannel', [[
        {src: './audio/01_Ad-Venire.ogg', type: 'audio/ogg'},
        {src: './audio/01_Ad-Venire.mp3', type: 'audio/mpeg'}
    ],
    soundOnOffControl.enabled,
    true
]);
let channels = [];
channels.push(new AudioChannel('channel_1', [[
        {src: './audio/01_Trump.ogg', type: 'audio/ogg'},
        {src: './audio/01_Trump.mp3', type: 'audio/mpeg'},
        {src: './audio/01_Trump.wav', type: 'audio/wav'}
    ],
    false
]));
channels.push(new AudioChannel('channel_2', [[
        {src: './audio/02_Oscar.ogg', type: 'audio/ogg'},
        {src: './audio/02_Oscar.mp3', type: 'audio/mpeg'},
        {src: './audio/02_Oscar.wav', type: 'audio/wav'}
    ],
    false
]));
channels.push(new AudioChannel('channel_3', [[
        {src: './audio/03_March_SpaceX.ogg', type: 'audio/ogg'},
        {src: './audio/03_March_SpaceX.mp3', type: 'audio/mpeg'},
        {src: './audio/03_March_SpaceX.wav', type: 'audio/wav'}
    ],
    false
]));
channels.push(new AudioChannel('channel_4', [[
        {src: './audio/04_Evtushenko.ogg', type: 'audio/ogg'},
        {src: './audio/04_Evtushenko.mp3', type: 'audio/mpeg'},
        {src: './audio/04_Evtushenko.wav', type: 'audio/wav'}
    ],
    false
]));
channels.push(new AudioChannel('channel_5', [[
        {src: './audio/05_Spartak.ogg', type: 'audio/ogg'},
        {src: './audio/05_Spartak.mp3', type: 'audio/mpeg'},
        {src: './audio/05_Spartak.wav', type: 'audio/wav'}
    ],
    false
]));
channels.push(new AudioChannel('channel_6', [[
        {src: './audio/06_Worm.ogg', type: 'audio/ogg'},
        {src: './audio/06_Worm.mp3', type: 'audio/mpeg'},
        {src: './audio/06_Worm.wav', type: 'audio/wav'}
    ],
    false
]));
channels.push(new AudioChannel('channel_7', [[
        {src: './audio/07_RAMP.ogg', type: 'audio/ogg'},
        {src: './audio/07_RAMP.mp3', type: 'audio/mpeg'},
        {src: './audio/07_RAMP.wav', type: 'audio/wav'}
    ],
    false
]));
channels.push(new AudioChannel('channel_8', [[
        {src: './audio/08_Battle.ogg', type: 'audio/ogg'},
        {src: './audio/08_Battle.mp3', type: 'audio/mpeg'},
        {src: './audio/08_Battle.wav', type: 'audio/wav'}
    ],
    false
]));
channels.push(new AudioChannel('channel_9', [[
        {src: './audio/09_Playboy.ogg', type: 'audio/ogg'},
        {src: './audio/09_Playboy.mp3', type: 'audio/mpeg'},
        {src: './audio/09_Playboy.wav', type: 'audio/wav'}
    ],
    false
]));
channels.push(new AudioChannel('channel_10', [[
        {src: './audio/10_Weinstein.ogg', type: 'audio/ogg'},
        {src: './audio/10_Weinstein.mp3', type: 'audio/mpeg'},
        {src: './audio/10_Weinstein.wav', type: 'audio/wav'}
    ],
    false
]));
channels.push(new AudioChannel('channel_11', [[
        {src: './audio/11_Revolution.ogg', type: 'audio/ogg'},
        {src: './audio/11_Revolution.mp3', type: 'audio/mpeg'},
        {src: './audio/11_Revolution.wav', type: 'audio/wav'}
    ],
    false
]));
channels.push(new AudioChannel('channel_12', [[
        {src: './audio/12_Bitcoin.ogg', type: 'audio/ogg'},
        {src: './audio/12_Bitcoin.mp3', type: 'audio/mpeg'},
        {src: './audio/12_Bitcoin.wav', type: 'audio/wav'}
    ],
    false
]));

if (soundOnOffControl.enabled)
    bgChannel.start();

//


slide0.on('show', () => {
    showIntro();
    setNeedAction();
    setMonth();
    bgCanvas.stop();
    if (currChannel)
        currChannel.stop();

    if (typeof analyticsEvent !== 'undefined') analyticsEvent('Section Intro: Version ' + (viewMode === '' ? 'Desktop' : 'Mobile'), 'view', 'Success');
    if (typeof analyticsEvent !== 'undefined') analyticsEvent('Section Intro', 'view', 'Success');
});
slide1.on('show', () => {
    playToSlide(1, stepValue);
});
slide2.on('show', () => {
    playToSlide(2, stepValue);
});
slide3.on('show', () => {
    playToSlide(3, stepValue);
});
slide4.on('show', () => {
    playToSlide(4, stepValue);
});
slide5.on('show', () => {
    playToSlide(5, stepValue);
});
slide6.on('show', () => {
    playToSlide(6, stepValue);
});
slide7.on('show', () => {
    playToSlide(7, stepValue);
});
slide8.on('show', () => {
    playToSlide(8, stepValue);
});
slide9.on('show', () => {
    playToSlide(9, stepValue);
});
slide10.on('show', () => {
    playToSlide(10, stepValue);
});
slide11.on('show', () => {
    playToSlide(11, stepValue);
});
slide12.on('show', () => {
    playToSlide(12, stepValue);
});
slide1.on('mode', (mode) => {
    playNewModeSlide(1, mode);
});
slide2.on('mode', (mode) => {
    playNewModeSlide(2, mode);
});
slide3.on('mode', (mode) => {
    playNewModeSlide(3, mode);
});
slide4.on('mode', (mode) => {
    playNewModeSlide(4, mode);
});
slide5.on('mode', (mode) => {
    playNewModeSlide(5, mode);
});
slide6.on('mode', (mode) => {
    playNewModeSlide(6, mode);
});
slide7.on('mode', (mode) => {
    playNewModeSlide(7, mode);
});
slide8.on('mode', (mode) => {
    playNewModeSlide(8, mode);
});
slide9.on('mode', (mode) => {
    playNewModeSlide(9, mode);
});
slide10.on('mode', (mode) => {
    playNewModeSlide(10, mode);
});
slide11.on('mode', (mode) => {
    playNewModeSlide(11, mode);
});
slide12.on('mode', (mode) => {
    playNewModeSlide(12, mode);
});

function playToSlide(index, stepValue) {

    if (currChannel)
        currChannel.stop();

    currChannel = index > 0 && index < channels.length + 1 ? channels[index - 1] : null;
    let delay = getDelay(Math.abs(stepValue));

    if (autoAction_timeout) clearTimeout(autoAction_timeout);
    if (currChannel_timeout) clearTimeout(currChannel_timeout);


    setNeedAction();
    setStepValue(Math.abs(stepValue));
    if (introCurrent()) {
        bgAnimation.goto(index, true);
        bgCanvas.play(index, 0, screen.mode);
        setMonth(index);

        playCurrentChannel();
    }
    else
        bgCanvas.play(index, delay, screen.mode).then(() => {
            setMonth(index);
            bgAnimation.goto(index);

            currChannel_timeout = setTimeout(playCurrentChannel, delay * 1000);
        });
    hideIntro();

    if (typeof analyticsEvent !== 'undefined') analyticsEvent('Section ' + index + ': Version ' + ( screen.mode === '' ? 'Desktop' : 'Mobile'), 'view', 'Success');
    if (typeof analyticsEvent !== 'undefined') analyticsEvent('Section ' + index, 'view', 'Success');

    function playCurrentChannel() {
        if (currChannel_timeout) clearTimeout(currChannel_timeout);
        if (currChannel)
        {
            if (soundOnOffControl.enabled)
                currChannel.unmute();
            else
                currChannel.mute();
            currChannel.start();
        }
    }

}

function playNewModeSlide(index, mode) {
    if ((mode === '' || viewMode === '') && mode !== viewMode) {
        if (typeof analyticsEvent !== 'undefined') analyticsEvent('Section version changed to ' + (mode === '' ? 'Desktop' : 'Mobile'), 'changed', 'Success');
    }
    viewMode = mode;
    if (autoAction_timeout) clearTimeout(autoAction_timeout);
    bgCanvas.play(index, 0, mode);
}

soundOnOffControl.on('unmute', function () {
    if (currChannel)
    {
        currChannel.start();
        currChannel.unmute();
    }
    if (bgChannel)
    {
        bgChannel.start();
        bgChannel.unmute();
    }
    if (typeof analyticsEvent !== 'undefined') analyticsEvent('Sound Button', 'click', 'On');
});

soundOnOffControl.on('mute', function () {
    if (currChannel)
        currChannel.mute();
    if (bgChannel)
        bgChannel.mute();

    if (typeof analyticsEvent !== 'undefined') analyticsEvent('Sound Button', 'click', 'Off');
});

// PRELOADER

let el = document.querySelector('#preloader-clip-rect');
let preloader1 = el ? new Preloader(el) : null;
el = document.querySelector('#preloader-clip-lines');
let preloader2 = el ? new Preloader(el) : null;

if (preloader1)
    preloader1.progress = bgCanvas.state.progress;
if (preloader2)
    preloader2.progress = bgCanvas.state.progress;


bgCanvas.on('initialLoadProgress', (evt) => {
    if (preloader1)
        preloader1.progress = evt.progress;
    if (preloader2)
        preloader2.progress = evt.progress;
}, this);

bgCanvas.on('initialLoadComplete', () => {
    initSW();
    document.body.dataset.ready = '1';
    singleton.dispatchEvent('ready');

    if (preloader1)
        preloader1.progress = 1;
    if (preloader2)
        preloader2.progress = 1;
    
    window.scrollTo(0, 10);

    bgCanvas.off('initialLoadProgress');
}, this, true);





bgCanvas.addEventListener('done', (evt) => {
    setNeedAction(evt.currentAnimationIndex);
    screen.current.activate(true);
    screen.current.on('act', () => {
        if (autoAction_timeout) clearTimeout(autoAction_timeout);
        bgCanvas.act();
        // SWITCH OFF ACTION WIN
        setNeedAction();
        if (typeof analyticsEvent !== 'undefined') analyticsEvent('Desktop: Action popup button. Section ' + screen.current.index, 'click', 'Action');
    });

    if (autoPlay) {
        autoAction_timeout = setTimeout(() => {
            bgCanvas.act();
            screen.current.act();
            // SWITCH OFF ACTION WIN
            setNeedAction();
        }, autoAction_delay);
    }
})



/*
 // SWITCH OFF ACTION WIN
bgCanvas.addEventListener('action', () => {
    if (autoAction_timeout) clearTimeout(autoAction_timeout);
    setNeedAction();
});*/

function addBGLayers(num) {
    let i;
    let bg = document.querySelector('#bg');
    let el;
    for (i = 0; i < num; i++)
    {
        el = crel( "span", { "class": "bg__layer" }, "");
        bg.appendChild(el);
    }
}

function getDelay(diff) {
    return diff > 0 ? bgAnimation.calculateDuration(diff) : 0.2;
}

let root = document.getElementById('scene');

let screen = new ScreenSlider(
    slide0,
    slide1,
    slide2,
    slide3,
    slide4,
    slide5,
    slide6,
    slide7,
    slide8,
    slide9,
    slide10,
    slide11,
    slide12,
    {
        root: root,
        loop: true
    }
);

screen.on('step', step => {

    if (step && step.previous)
    {
        stepValue = step.current.index - step.previous.index;
        step.previous.activate(false);
    }
    else
        stepValue = 0;

    updateSW();
});




// intro
const intro = document.querySelector('#intro .scene__container');
function introCurrent() {
    return parseInt(document.body.dataset.intro) === 1;
}
function showIntro () {
    if (introCurrent()) return;

    if (intro) {
        intro.style.transform = `translate3d(0, 0, 0)`;
        document.body.dataset.intro = 1;
    }
}
function hideIntro () {
    if (!introCurrent()) return;

    if (intro) {
        intro.style.transform = `translate3d(0, -100%, 0)`;
        document.body.dataset.intro = 0;
    }
}


// Scroll /by means of Swiper/

function initSW () {
    sw = new Swiper(document.querySelector('#scene').parentNode, {
        speed: 700,
        direction: 'vertical',
        effect: 'fade',
        transforms3d: true,
        preventClicks: false,
        preventClicksPropagation: false,
        touchMoveStopPropagation: false,
        //shortSwipes: false,
        loop: true,
        slideClass: 'slide',
        wrapperClass: 'scene__container',
        //touchEventsTarget: val === 'portrait' ? 'wrapper' : 'container',
        spaceBetween: 0,
        //virtualTranslate: true,
        followFinger: true,
        mousewheel: {
            enabled: true,
            eventsTarged: 'container'
        },
        keyboard: {
            enabled: true
        }
    });

    sw.on('slideChange', function () {
        screen.goTo(sw.realIndex);
    });

    updateSW();
}


function updateSW() {
    if (!sw) return;
    sw.slideTo(screen.current.index + (sw.params.loop ? sw.loopedSlides : 0));
    sw.allowSlidePrev = screen.current.index > 0;
}


// mobile: TRACKING SYNOPSIS STATE TO ENABLE/DISABLE SWIPER
const synopsis = require('./synopsis');
synopsis.on('opened', () => {
    sw.allowSlidePrev = false;
    sw.allowSlideNext = false;
    if (typeof analyticsEvent !== 'undefined') analyticsEvent('Mobile: Know more button. Section ' + screen.current.index, 'click', 'Open');
});

synopsis.on('closed', () => {
    sw.allowSlidePrev = screen.current.index > 0;
    sw.allowSlideNext = true;
});


/*{
    const obj = {
        'prev': () => screen.go(-1),
        'next': () => screen.go(1),
        'removeAll': () => screen.removeAll(),
        'console': () => cl(screen),
        'goTo': 0,

        'removeSlide6': () => screen.remove(slide6),
        'removeSlide2': () => screen.remove(slide2)
    };

    const gui = require('./gui');
    
    gui.add(obj, 'prev');
    gui.add(obj, 'next');
    gui.add(obj, 'console');
    // gui.add(obj, 'removeSlide2');
    // gui.add(obj, 'removeSlide6');
    // gui.add(obj, 'removeAll');
    // gui.add(obj, 'goTo', -10, 10)
    //     .step(1)
    //     .onChange(num => {
    //         screen.goTo(num);
    //     });
}*/

const singleton = {
    screen: screen,
    slides: [
        slide0,
        slide1,
        slide2,
        slide3,
        slide4,
        slide5,
        slide6,
        slide7,
        slide8,
        slide9,
        slide10,
        slide11,
        slide12
    ],
    getSlideName: function () {
        const format = (value) => {
            let s = value.toString();
            if (s.length > 1) return s;
            return '0'+s;
        }

        if (introCurrent()) return 'intro';
        return format(document.body.dataset.month);
    },
    setAnalyticsFunction: function (f) {
        analyticsEvent = f;
    }
}
createjs.EventDispatcher.initialize(singleton);

module.exports = singleton;


// WEBPACK FOOTER //
// ./js/slider.js